import { postAsync, getAsync } from './_base';

const postAddProductToWatchList = (apiUrl?: string, sku?: string) => {
  return postAsync(apiUrl ?? '', undefined, {
    sku: sku,
  });
};

const postAddProductToCart = (apiUrl?: string, productObj?: any) => {
  return postAsync(apiUrl ?? '', undefined, productObj);
};

const getGetVariants = (apiUrl?: string, currency?: string) => {
  return getAsync(apiUrl ?? '', { currency: currency });
};

const getShareProductLink = (apiUrl?: string, productObj?: any) => {
  return postAsync(apiUrl ?? '', undefined, productObj);
};

const getCategoriesAndSubCategories = (apiUrl?: string, sku?: string, publisherId?: string) => {
  return getAsync(apiUrl ?? '', {
    sku: sku,
    publisherid: publisherId,
  });
};

export { postAddProductToWatchList, postAddProductToCart, getCategoriesAndSubCategories, getGetVariants, getShareProductLink };
